import ResendVerificationEmailForm from './ResendVerificationEmailForm'
import {connect} from 'react-redux'
import styles from './style.css'
import AuthTitle from 'components/Titles/AuthTitle'
import NotificationModal from './NotificationModal'
import {resendVerificationEmail, setResendEmailVerificationState, toLoginPage, toSignUpPage} from 'actions'

class ResendVerificationEmail extends React.Component {
  render () {
    return (
      <div className={styles.root}>
        <AuthTitle title='Resend Verification Email' />
        <div className={`text-center mb-40px ${styles['text-margin-resend']}`}>
          <p className='no-margin'>
            Please enter your email address and we will
          </p>
          <p className='no-margin'>
          re-send you a verification email.
          </p>
        </div>
        <ResendVerificationEmailForm
          history={this.props.history}
          onSubmit={this.handleSubmit}
        />
        <NotificationModal
          isShow={this.props.resendVerificationEmail.isModalShow}
          headerMessage={this.props.resendVerificationEmail.headerMessage}
          bodyMessage={this.props.resendVerificationEmail.bodyMessage}
          btnConfirm='Sign In'
          btnHide='Close'
          onHide={this.onEmailAlreadyRegisteredModalHide}
          onConfirm={this.onEmailAlreadyRegisteredModalConfirm}
          isNotificationError={this.props.resendVerificationEmail.modalStatus}
        />
      </div>
    )
  }

  /**
   * Handle submit from redux from
   * @param values json object contains {email}
   */
  handleSubmit = (values) => {
    let {email} = values
    this.props.dispatch(resendVerificationEmail(email))
  }

  onEmailAlreadyRegisteredModalConfirm = () => {
    this.props.dispatch(setResendEmailVerificationState({isModalShow: false}))
    if (this.props.resendVerificationEmail.modalStatus === 'unregistered') {
      this.props.dispatch(toSignUpPage())
    } else {
      this.props.dispatch(toLoginPage())
    }
  }

  onEmailAlreadyRegisteredModalHide = () => {
    this.props.dispatch(setResendEmailVerificationState({isModalShow: false}))
  }
}

// ResendVerificationEmail.propTypes = {
//   form: React.PropTypes.object,
//   history: React.PropTypes.object,
//   dispatch: React.PropTypes.func
// }

function mapStateToProps (state) {
  return {
    form: state.form,
    resendVerificationEmail: state.moka.resendVerificationEmail
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchToProps)(ResendVerificationEmail)



// WEBPACK FOOTER //
// ./app/pages/ResendVerificationEmail/ResendVerificationEmail.js